// Ticket severity — P0 is most urgent. Mirrors EscalationSeverity on the backend.
export const SEVERITY_META = {
    P0: { label: "P0 — Critical", bg: "#FDECEA", color: "#C0392B", border: "#F5C6C0" },
    P1: { label: "P1 — High", bg: "#FFF4E5", color: "#B45309", border: "#FBD9A8" },
    P2: { label: "P2 — Normal", bg: "#EEF2F7", color: "#41556B", border: "#D5DEE8" },
};
export const SEVERITY_OPTIONS = ["P0", "P1", "P2"].map((value) => ({ value, label: SEVERITY_META[value].label }));
